import { render } from "./NcrmMitpLeadBoardDialog.vue?vue&type=template&id=5dde2960"
import script from "./NcrmMitpLeadBoardDialog.vue?vue&type=script&lang=js"
export * from "./NcrmMitpLeadBoardDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__